import {
  FormItem,
  SelectInput,
  TextInput,
  useFormField,
} from '@framework/form';
import React from 'react';
import { $SpaceCompact } from '../../../../ui/form/SpaceCompact';
import { RuleType } from '../../IRule';
import { CustomValidationRuleMessage } from '../custom/CustomValidationRuleMessage';
import { TextFormat } from './TextFormat.rule';

const FIELD_NAME = `rules.${RuleType.TextFormat}`;

export function TextFormatRuleComponent() {
  const formatFieldName = `${FIELD_NAME}.format`;
  const formatCustomFieldName = `${FIELD_NAME}.customFormat`;
  const formatCustomValidationMessage = `${FIELD_NAME}.customMessage`;

  const formatField = useFormField(formatFieldName);

  return (
    <>
      <FormItem name={formatFieldName} label="Formato">
        <$SpaceCompact block size="large">
          <SelectInput
            name={formatFieldName}
            allowClear
            onClear={() => {
              formatField.onChange(null);
            }}
            options={[
              {
                label: 'Email',
                value: TextFormat.Email,
              },
              {
                label: 'Numero',
                value: TextFormat.Number,
              },
              {
                label: 'Partita IVA',
                value: TextFormat.Piva,
              },
              {
                label: 'Codice Fiscale',
                value: TextFormat.FiscalCode,
              },
              {
                label: 'Telefono',
                value: TextFormat.Phone,
              },
              {
                label: 'Personalizzato (espressione regolare)',
                value: TextFormat.Custom,
              },
            ]}
          />
          <CustomValidationRuleMessage name={formatCustomValidationMessage} />
        </$SpaceCompact>
      </FormItem>
      <FormItem
        name={formatCustomFieldName}
        label="Formato personalizzato"
        help={
          'Inserire un’espressione regolare per validare il testo inserito dall’utente.'
        }
      >
        <TextInput name={formatCustomFieldName} />
      </FormItem>
    </>
  );
}
